<template>
    <top-bar :page="'stories'" :leftText="'Stories'" />
    <div class="stories-display">
        <div class="row" v-if="store.stories.length > 0">
            <div
                class="col-sm-3 mb-2"
                v-for="(story, index) in store.stories"
                :key="index"
            >
                <story-box :story="story" />
            </div>
        </div>
    </div>
</template>

<script>
import TopBar from "./TopBar.vue";
import StoryBox from "./StoryBox.vue";
import { useRosterStore } from "@/stores";

export default {
    name: 'Stories',
    components: {
        TopBar,
        StoryBox
    },
    data() {
        return {
            store: useRosterStore(),
        };
    },
    methods: {
        // Define your component methods here
    },
    mounted() {
        // Code to run when the component is mounted
    }
};
</script>

<style scoped>
.stories-display {
    padding: 20px;
}
</style>
